(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', (e) => {
    const visualBtn = e.target.closest('[data-visual-search]');
    if (visualBtn) {
      const form = visualBtn.closest('form');
      const fileInput = form ? form.querySelector('.msb-file') : null;
      if (fileInput) fileInput.click();
      return;
    }

    const clearBtn = e.target.closest('.msb-btn--clear');
    if (clearBtn) {
      const form = clearBtn.closest('.msb-form');
      const searchInput = form ? form.querySelector('.msb-input') : null;
      const searchBtn = form ? form.querySelector('.msb-btn--search') : null;

      if (searchInput) {
        searchInput.value = '';
        searchInput.focus();
        searchInput.dispatchEvent(new Event('input', { bubbles: true }));
      }

      if (searchBtn) {
        searchBtn.removeAttribute('hidden');
      }

      clearBtn.setAttribute('hidden', 'true');
      return;
    }
  });

  document.addEventListener('input', (e) => {
    const input = e.target.closest('.msb-input');
    if (!input) return;

    const form = input.closest('.msb-form');
    if (!form) return;

    const searchBtn = form.querySelector('.msb-btn--search');
    const clearBtn = form.querySelector('.msb-btn--clear');

    if (input.value.trim().length > 0) {
      if (searchBtn) searchBtn.setAttribute('hidden', 'true');
      if (clearBtn) clearBtn.removeAttribute('hidden');
    } else {
      if (searchBtn) searchBtn.removeAttribute('hidden');
      if (clearBtn) clearBtn.setAttribute('hidden', 'true');
    }
  });

  document.addEventListener('change', async (e) => {
    const input = e.target.closest('.msb-file');
    if (!input) return;

    const file = input.files && input.files[0];
    if (!file) return;

    const endpoint = window.VISUAL_SEARCH_ENDPOINT || null;

    if (!endpoint) {
      alert('Búsqueda por imagen: falta conectar un servicio/app (endpoint).');
      input.value = '';
      return;
    }

    try {
      const fd = new FormData();
      fd.append('image', file);

      const res = await fetch(endpoint, { method: 'POST', body: fd });
      const data = await res.json();

      if (data && data.redirect_url) {
        window.location.href = data.redirect_url;
      } else {
        alert('No se recibieron coincidencias (endpoint sin redirect_url).');
      }
    } catch (err) {
      console.error(err);
      alert('Error procesando la imagen.');
    } finally {
      input.value = '';
    }
  });

  function cleanGhostUI() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    document.querySelectorAll('.menu-drawer__close, .header__drawer-close, .menu-drawer__header .icon-close, .menu-drawer .icon-close, dialog-menu .icon-close, .header__drawer .icon-close').forEach((el) => {
      if (!el.closest('summary.header__icon--menu')) {
        el.style.display = 'none';
        el.style.opacity = '0';
        el.style.pointerEvents = 'none';
      }
    });

    document.querySelectorAll('.mobile-search-bar .predictive-search__close, .mobile-search-bar .search__clear, .mobile-search-bar .field__button, .mobile-search-bar .reset__button').forEach((el) => {
      el.style.display = 'none';
      el.style.width = '0';
      el.style.height = '0';
      el.style.opacity = '0';
      el.style.pointerEvents = 'none';
      el.style.position = 'absolute';
    });
  }

  document.addEventListener('DOMContentLoaded', cleanGhostUI);
  document.addEventListener('click', () => {
    setTimeout(cleanGhostUI, 30);
    setTimeout(cleanGhostUI, 120);
  });
  document.addEventListener('input', () => {
    setTimeout(cleanGhostUI, 30);
  });
  window.addEventListener('resize', cleanGhostUI);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
